import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  create_mentor_education_data_action,
  delete_mentor_education_by_id_data_action,
  get_mentor_all_educational_data_action,
  update_mentor_education_by_id_data_action,
  get_mentor_education_by_id_data_action,
} from "../../../../redux/_actions/mentor";
import { FIELD_OF_STUDY, DEGREE_TYPE } from "../constants";
import { showWarningMessage } from "../../../../_uiComponents/ShowMessageSnack";

function useEducationalInformation(props) {
  const [allEducationalData, setAllEducationalData] = useState([]);
  const [loadingEducation, setLoadingEducation] = useState(false);
  const [educationFormData, setEducationFormData] = useState({});
  const [educationFormDataLoading, setEducationFormDataLoading] = useState({});
  const [editEducationItemId, setEditEducationItemId] = useState(null);
  const [educationStartDate, setEducationStartDate] = useState();
  const [educationEndDate, setEducationEndDate] = useState();
  const [degree, setDegree] = useState([]);
  const [fieldOfStudy, setFieldOfStudy] = useState([]);
  const [newEducationAdded, setNewEducationAdded] = useState(false);


  const dispatch = useDispatch();

  //get data from redux
  const { userEducationalData } = useSelector(
    (state) => state.get_mentor_all_educational_data_reducer
  );
  const { userEducationByIdData } = useSelector(
    (state) => state.get_mentor_education_by_id_data_reducer
  );

  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (userEducationalData?.data) {
      setAllEducationalData(userEducationalData?.data);
    }
  }, [userEducationalData]);

  useEffect(() => {
    if (userEducationByIdData?.data) {

      let data = userEducationByIdData?.data;
      data["college_degree"] = data["college_degree_name"]
      data["field_of_study"] = data["field_of_study_name"]
      data["school"] = data["school_name"]

      setEducationFormData(userEducationByIdData?.data);
    }
  }, [userEducationByIdData]);

  //set dropdown choices
  useEffect(() => {
    setDegree(DEGREE_TYPE);
    setFieldOfStudy(FIELD_OF_STUDY);
  }, []);

  
  const callApi = async () => {
    await dispatch(get_mentor_all_educational_data_action());
  }

  const callEducationApi = async (id) => {
    setEducationFormDataLoading(true);
    await dispatch(get_mentor_education_by_id_data_action(id));
    setEducationFormDataLoading(false);
  };

  const onEducationFormDataChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let data = educationFormData;
    // set data values
    data[name] = value;
    setEducationFormData(data);
  };

  const onSubmitForm = async () => {
    if (educationFormData?.id) {
      await dispatch(
        update_mentor_education_by_id_data_action(
          educationFormData,
          educationFormData.id
        )
      );
    } else if (educationFormData?.college_degree === "" || !educationFormData?.college_degree && educationFormData?.degree_type === "" || !educationFormData?.degree_type) {
      showWarningMessage("please fill all the field.")
    } else {
      await dispatch(create_mentor_education_data_action(educationFormData));
    }
    await dispatch(get_mentor_all_educational_data_action());
    setEducationFormData({});
    setEditEducationItemId(null);
    setNewEducationAdded(false);
  };

  const deleteUserEducation = async (id) => {
    await dispatch(delete_mentor_education_by_id_data_action(id));
    setLoadingEducation(true);
    await dispatch(get_mentor_all_educational_data_action());
    setLoadingEducation(false);
  };

  // onDateChange

  const onDateChange = async (date, key) => {
    let convertDate = (date) => {
      var date = new Date(date),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    };
    let formatDate = convertDate(date);
    let educationStartDateObj = educationFormData;
    educationStartDateObj[key] = formatDate;
    setEducationStartDate(date);
    setEducationEndDate(date);
    setEducationFormData(educationStartDateObj);
  };

  const onEditEducationItemClick = (id) => {
    setEditEducationItemId(id);
    callEducationApi(id);
  };

  const onEditEducationCancelClick = () => {
    setEditEducationItemId(null);
  };

  const onAddNewEducationClick = () => {
    setNewEducationAdded(true);
    setEducationFormData({});
  };

  const onNewEducationCancelClick = () => {
    setNewEducationAdded(false)
  };

  return {
    allEducationalData,
    loadingEducation,
    educationFormData,
    educationFormDataLoading,
    editEducationItemId,
    educationEndDate,
    educationStartDate,
    newEducationAdded,
    degree,
    fieldOfStudy,
    onEducationFormDataChange,
    onSubmitForm,
    deleteUserEducation,
    onDateChange,
    onEditEducationItemClick,
    onEditEducationCancelClick,
    onAddNewEducationClick,
    onNewEducationCancelClick
  };
}

export default useEducationalInformation;
